<template>
  <div>
    <!-- <h2>Nemoci z koupání</h2> -->
    <p>
      Zaznamenali jste zdravotní potíže v souvislosti s koupáním? Informujte
      nás, prosím, prostřednictvím
      <a
        href="http://www.szu.cz/tema/zivotni-prostredi/dotaznik-zdravotni-problemy-vznikle-v-dusledku-koupani-nebo"
        target="_blank"
      >
        dotazníku
      </a>
      .
    </p>
  </div>
</template>

<script>
export default {
  mounted() {
    this.$emit("caption", "Nemoci z koupání");
  }
};
</script>

<style scoped>
.side {
  padding: 2.5em;
  font-family: Arial, Helvetica, sans-serif;
  padding-top: 0;
}
</style>
